import useApi from '@/hooks/useApi';
import useInertiaData from '@/hooks/useInertiaData';
import React, { useEffect } from 'react';
import AdminBar from '@/components/AdminBar';
import BetaFeedbackWidget from '@/components/BetaFeedbackWidget';
import { Header, Sidebar } from './partials';

interface AppLayoutProps {
    children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    const { user, no_billing_order_record } = useInertiaData();
    const api = useApi();

    // Enforce no-billing-order access on Inertia navigations (middleware handles direct browser requests)
    const shouldBlockForNoBillingOrder = (() => {
        if (!no_billing_order_record) {
            return false;
        }
        if (window.location.pathname.startsWith('/no-billing-order')) {
            return false;
        }
        const createdAt = new Date(no_billing_order_record.created_at);
        const daysSince =
            (Date.now() - createdAt.getTime()) / (1000 * 60 * 60 * 24);
        return daysSince >= 7;
    })();

    useEffect(() => {
        if (shouldBlockForNoBillingOrder) {
            window.location.href = '/no-billing-order/';
        }
    }, [shouldBlockForNoBillingOrder]);

    useEffect(() => {
        if (!user) {
            return;
        }

        const detectedTimezone =
            Intl.DateTimeFormat().resolvedOptions().timeZone;

        console.log('detectedTimezone', detectedTimezone);

        if (user.timezone !== detectedTimezone) {
            api.post('/api/update-timezone/', {
                timezone: detectedTimezone,
            }).catch((error) => {
                console.error('Failed to update timezone:', error);
            });
        }
    }, [user?.timezone, user, api]);

    return (
        <div className="flex min-h-screen flex-col bg-gray-50">
            <AdminBar />
            <div className="flex flex-1">
                <Sidebar />

                {/* Main Content */}
                <div className="flex min-w-0 flex-1 flex-col">
                    <Header />

                    {/* Main Content Area */}
                    <main className="flex-1 p-4 sm:p-6 lg:p-8">
                        {shouldBlockForNoBillingOrder ? null : children}
                    </main>
                </div>
            </div>

            {/* <BetaFeedbackWidget /> */}
        </div>
    );
};

export default AppLayout;
